import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
export const CMS_CONFIG_ACCOUNT = 'account';

export interface IICmsConfigAccountDataContent extends IConfigData {
    orderHistoryMode?: string;
}
export interface IICmsConfigAccountData extends ICmsConfig<IICmsConfigAccountDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_ACCOUNT,
    name: 'Account configuration',
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'orderHistoryMode',
            title: 'Order history mode',
            description: 'Only for Trade website',
            default: 'auto',
            options: [
                {
                    key: 'auto',
                    title: 'Auto'
                },
                {
                    key: 'old',
                    title: 'Old'
                },
                {
                    key: 'new',
                    title: 'New'
                }
            ]
        }
    ]
});
